module.exports = __webpack_public_path__ + "static/media/regions2.d1325ee7.png";